module.exports = __webpack_public_path__ + "im.f7622393971d94129642.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/im.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/im.svg
// module chunks = styles